import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary as PrimaryButton, Secondary, Text } from "@cinch-labs/design-system";
import React from "react";
import styles from "./landing-feature-error-page.module.css";
export function getStaticProps(context) {
    return {
        props: {
            generatedAt: Date.now().toString(),
            layoutProps: {
                showBorderRadius: true
            }
        },
        revalidate: 300
    };
}
export function LandingFeatureErrorPage(param) {
    var title = param.title, subTitle = param.subTitle, Image = param.image, hasCta = param.hasCta, ctaHref = param.ctaHref, ctaText = param.ctaText, searchCarsCtaText = param.searchCarsCtaText;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles["container"],
        children: [
            title ? /*#__PURE__*/ _jsx(Text, {
                element: "h1",
                className: styles["errorPageTitle"],
                children: title
            }) : null,
            subTitle ? /*#__PURE__*/ _jsx(Text, {
                className: styles["errorPageSubTitle"],
                element: "h2",
                children: subTitle
            }) : null,
            Image ? /*#__PURE__*/ _jsx("span", {
                className: styles["errorPageImage"],
                children: /*#__PURE__*/ _jsx(Image, {})
            }) : null,
            hasCta ? /*#__PURE__*/ _jsxs("div", {
                className: styles["actionButtons"],
                children: [
                    /*#__PURE__*/ _jsx(PrimaryButton, {
                        element: "a",
                        href: ctaHref,
                        children: ctaText
                    }),
                    searchCarsCtaText && searchCarsCtaText !== "" ? /*#__PURE__*/ _jsx(Secondary, {
                        element: "a",
                        href: "/find-vehicle",
                        children: searchCarsCtaText
                    }) : null
                ]
            }) : null
        ]
    });
}
